import { useTranslation } from "react-i18next";
import TableFilter, {
  FilterField,
} from "../../../components/Common/TableFilter/TableFilter";
import AddEditExpenseCategoryModal from "../modals/AddEditExpenseCategoryModal";
import ExpenseCategoriesTable from "../tables/ExpenseCategoriesTable";
import useExpenseCategories from "../hooks/useExpenseCategories";
import { useEffect, useState } from "react";
import TableFilterDynamique from "components/Common/TableFilter/TableFilterDynamique";
import SettingsLayout from "../components/SettingsLayout";
import CustomButton from "components/Common/ui/CustomButton";

const ExpenseCategories = () => {
  const { t } = useTranslation();
  const {
    categories,
    infoPagination,
    loading,
    error,
    selectedCategory,
    setSelectedCategory,
    isModalOpen,
    setIsModalOpen,
    fetchExpenseCategories,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useExpenseCategories();


  const [filters, setFilters] = useState<{
    [key: string]: string | number | null;
  }>({});

  useEffect(() => {
    fetchExpenseCategories();
  }, [fetchExpenseCategories]);

  const filterFields: FilterField[] = [
    { key: "search", label: t("search"), type: "text" },
  ];

  const handleSaveExpenseCategory = async (categoryData: any) => {
    if (selectedCategory) {
      await handleUpdate(selectedCategory.id, categoryData);
    } else {
      await handleCreate(categoryData);
    }
    setIsModalOpen(false);
  };

  const handleEdit = (record: any) => {
    setSelectedCategory(record);
    setIsModalOpen(true);
  };

  const handleFilter = (newFilters: {
    [key: string]: string | number | null;
  }) => {
    setFilters(newFilters);
    fetchExpenseCategories(newFilters);
  };

  return (
    <SettingsLayout titleKey="expense_categories" loading={loading}>
      <div className="d-flex mb-3 justify-content-end gap-2">
        <CustomButton
          onClick={() => {
            setSelectedCategory(null);
            setIsModalOpen(true);
          }}
        >
          <i className="ti ti-plus me-2" />
          {t("add_expense_category")}
        </CustomButton>
        <TableFilterDynamique
          fields={filterFields}
          filters={filters}
          onApply={(newFilters) => handleFilter(newFilters)}
          onReset={() => {
            setFilters({});
            fetchExpenseCategories({});
          }}
        />
      </div>

      <ExpenseCategoriesTable
        dataSource={categories}
        onEdit={handleEdit}
        onDelete={handleDelete}
        loading={loading}
      />

      <AddEditExpenseCategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        categoryData={selectedCategory}
        onSave={handleSaveExpenseCategory}
      />
    </SettingsLayout>
  );
};

export default ExpenseCategories;
